import React from 'react'
import './MessageCodes.css'

const MessageA3f = (props) => {
    let isDisabledInWorkflowTab = false;

    if (props.isWorkflowTab) {
        try {
            isDisabledInWorkflowTab = JSON.parse(props?.item?.data || "{}")?.qt_disable === "yes";
        } catch (error) {
            isDisabledInWorkflowTab = false;
        }
    }

    if (isDisabledInWorkflowTab) return null;
    if (props?.item?.text === "") return null;

    return (
        <div style={{ width: !props?.item?.data === 'center' && "fit-content" }}>
            <div
                id="main-tab1"
                style={{padding : '4px'}}
                className='A3f'
                dangerouslySetInnerHTML={{ __html: props?.item?.text }}  // Allowing raw HTML
            />

        </div>
    )
}

export default MessageA3f
